import {useLocation, useRoutes} from 'react-router-dom';

import GlobalConfirmDialog from '@/components/common/ConfirmDialog';
import PopupModal from '@/components/common/PopupModal.tsx';
import GlobalToast from '@/components/common/Toast';

import {useAppRoutes} from './routes';

const App = () => {
  const element = useRoutes(useAppRoutes());
  const location = useLocation();
  const isMngtOrLoginPage = location.pathname.includes('/mngt') || location.pathname.includes('/login');

  return (
    <>
      {element}
      {!isMngtOrLoginPage && <PopupModal />}
      <GlobalToast />
      <GlobalConfirmDialog />
    </>
  );
};

export default App;
